module.exports = __webpack_public_path__ + "static/bottom-ead6d4946748c344b345f80415958f02.png";